
import Vue from "vue";
import CrmHistory from "@/models/crm/crm-history";

export default Vue.extend({
	data() {
		return {};
	},
	props: {
		event: {
			required: true,
			type: Object as () => CrmHistory
		},
	},
	components: {
	}
});
